import { styled } from 'dripsy';
import React from 'react';
import { ModalComponentProp } from 'react-native-modalfy';
import { Linking, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { applicationStoreURLs } from '@constants';
import { ModalStackParamsType } from '../../modals/types';
import { BaseText } from '../common/BaseText';
import { Separator } from '../common/Separator';
import { Image } from '../common/Image';
import { Touchable } from '../common/Touchable';
import { BottomModalView } from './components/BottomModalView';

const ModalViewContainer = styled(BottomModalView)({
  px: '$6',
  alignItems: 'center',
});

const TopLine = styled(View)({
  backgroundColor: '$background30',
  height: 6,
  width: 60,
  borderRadius: 3,
  alignSelf: 'center',
});

const Title = styled(BaseText)({
  textAlign: 'center',
  variant: 'text.xxlarge',
  fontWeight: 'semi',
});

const RowContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'flex-start',
});

const DownloadImage = styled(Image)({
  width: 135,
  height: 46,
});

type ModalPropsType = ModalComponentProp<
  ModalStackParamsType,
  void,
  'MobileAppSuggestionModal'
>;

export function MobileAppSuggestionModal(_: ModalPropsType) {
  const { t } = useTranslation();

  function openInGooglePlayStore() {
    Linking.openURL(applicationStoreURLs.GOOGLE_PLAY_STORE);
  }

  function openInAppleStore() {
    Linking.openURL(applicationStoreURLs.APPLE_APP_STORE);
  }

  return (
    <ModalViewContainer>
      <Separator />
      <TopLine />

      <Separator size="$7" />
      <Title>{`${t('common.mobileAppSuggestion.title')} 📱`}</Title>

      <Separator size="$8" />
      <RowContainer>
        <Touchable onPress={openInGooglePlayStore}>
          <DownloadImage
            source={require('../../../assets/images/google-download-badge-dark.png')}
          />
        </Touchable>

        <Separator size="$8" vertical />
        <Touchable onPress={openInAppleStore}>
          <DownloadImage
            source={require('../../../assets/images/apple-download-badge-dark.png')}
          />
        </Touchable>
      </RowContainer>
      <Separator size="$9" />
    </ModalViewContainer>
  );
}
